// ----------------------------------------------------------------------------
// Feature Detection
// ----------------------------------------------------------------------------
//
// Docs: https://www.notion.so/iTF-Feature-Detection-cf1e905ae2d14c0b9ae3b161b4898af8
//
// ----------------------------------------------------------------------------

class FeatureDetect {
    static results = {};

    static addTest(name, test) {
        const className = `${name}`;
        const notClassName = `no-${name}`;

        // Run the test
        const isSupported = !!test();

        // Update the class names based on the test result
        document.documentElement.classList.remove(isSupported ? notClassName : className);
        document.documentElement.classList.add(isSupported ? className : notClassName);

        // Save the test result
        this.results[name] = isSupported;
    }

    static supports(name) {
        return this.results[name] || false;
    }
}


// -------------------------------------
// Detect Cookie Support and add a Class
// -------------------------------------

FeatureDetect.addTest('cookies', () => {
    var cookieEnabled = navigator.cookieEnabled;

    if (!cookieEnabled) {
        document.cookie = 'testcookie=1; max-age=5';
        cookieEnabled   = document.cookie.indexOf('testcookie') !== -1;
    }

    return cookieEnabled;
});
